<template>
  <div class="background_index_index">
    <div class="index_text">
      <p style="font-size: 20px;margin-bottom: 0">15 Years+｜350 Companies+</p>
      <p style="font-size: 20px;">$3.5 Billion+｜70 Exits+</p>
      <p style="padding-bottom: 1vh">————————</p>
     <p>Headquartered in the US, SIG is a global proprietary trading and broker-dealer firm founded with an
        entrepreneurial mindset and a rigorous analytical approach to</p>
      <p>decision making. Over the past 35 year, SIG's business thrives at the intersection of trading, quantitative
        research, and technology.</p>
      <p>SIG now has over 2,500 employees worldwide.</p>
      <p>SIG began investing in private equity/venture capital in the China market in 2005 and has focused on investment
        in companies mainly operating in the People’s Republic</p>
      <p>of China. SIG invests across the continuum of the venture capital life-cycle, from early to late stage, and in
        a variety of industry sectors. In the last decade,</p>
      <p>SIG has invested in over 350 companies including leading players such as ByteDance, Agora, Bona Film, Boohee,
        ClassIn, Cloudwise, CSC, Damai, Finch,</p>
      <p>Flash Delivery, Musical.ly, Palfish, PatPat, Ramen Talk, TTP Car, VSPN, Ximalaya,
        XtalPi, Yalla, Yitiao, Yunxuetang, Zhiyun Health, Zuiyou,</p>
      <p>with total investment amount exceeding $3.5 billion. SIG has achieved IPO, M&A or other exits in more than 70
        companies.</p>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/"
import {onMounted, reactive} from 'vue'

export default {
  name: 'Index_index_en_m',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.background_index_index {
  background-image: url("../../../assets/background/index_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_text {
  padding-top: 14vh;
  height: 92vh;
}

.index_text p {
  font-size: 11px;
  margin-bottom: 0.5em;
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}

</style>
